var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.904 19.558a1.25 1.25 0 01-.084-1.667l.091-.1 6.596-6.54-15.715-.001a1.25 1.25 0 01-.128-2.494l.128-.006h15.715L10.91 2.21a1.25 1.25 0 01-.098-1.666l.091-.102A1.25 1.25 0 0112.57.344l.102.09 8.75 8.678a1.26 1.26 0 01.366.787 1.286 1.286 0 01.004.101v.021l-.004.08.004-.101a1.262 1.262 0 01-.24.737 1.132 1.132 0 01-.038.049l-.092.102-8.75 8.677a1.25 1.25 0 01-1.768-.007z","fill":"currentColor","fillRule":"nonzero"}));
}

Arrow.defaultProps = {"viewBox":"0 0 22 20"};

module.exports = Arrow;

Arrow.default = Arrow;
